import { useTheme } from "../../contexts/ThemeContext";

export default function StatCard({ icon, label, value, sub, color }) {
  const { C } = useTheme();
  return (
    <div
      style={{
        background: C.bgCard,
        borderRadius: 14,
        padding: "20px 22px",
        border: `1px solid ${C.border}`,
        flex: 1,
        minWidth: 160,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: 10,
            background: (color || C.accent) + "18",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 18,
          }}
        >
          {icon}
        </div>
        <span
          style={{
            color: C.textMuted,
            fontSize: 12,
            fontWeight: 500,
            textTransform: "uppercase",
            letterSpacing: 0.8,
          }}
        >
          {label}
        </span>
      </div>
      <div style={{ fontSize: 26, fontWeight: 700, color: C.text }}>{value}</div>
      {sub && (
        <div style={{ fontSize: 12, color: C.textMuted, marginTop: 4 }}>{sub}</div>
      )}
    </div>
  );
}
